import { styled } from '@mui/material/styles'

interface CountDotProps {
    inverted?: boolean
}

export const CountDot = styled('span', {
    shouldForwardProp: (prop) => prop !== 'inverted' && prop !== 'sx',
})<CountDotProps>(({ theme, inverted }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '14px',
    padding: `0 ${theme.spacing(0.375)}`,
    borderRadius: '999px',
    backgroundColor: inverted
        ? theme.palette.common.white
        : theme.palette.action.hover,
    color: inverted ? theme.palette.common.black : theme.palette.text.primary,
    fontSize: '0.65rem',
    fontWeight: 700,
    lineHeight: 1.3,
    whiteSpace: 'nowrap',
}))
